import {
  EntityKindPicker,
  EntityLifecyclePicker,
  EntityNamespacePicker,
  EntityOwnerPicker,
  EntityProcessingStatusPicker,
  EntityTagPicker,
  EntityTypePicker,
  UserListPicker,
} from '@backstage/plugin-catalog-react';

export const CatalogFilters = () => (
  <>
    <EntityKindPicker initialFilter="component" />
    <EntityTypePicker />
    <UserListPicker initialFilter="owned" />
    <EntityOwnerPicker />
    <EntityTagPicker />
    {/* Keep the pickers mounted so hiding their controls does not remove filter state handling. */}
    <div hidden>
      <EntityLifecyclePicker />
      <EntityProcessingStatusPicker />
      <EntityNamespacePicker />
    </div>
  </>
);
